import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useLocation } from "wouter";
import { getSeo, renderSeoHead } from "@/lib/seo";
import { localizedPath } from "@/lib/site";

export default function Seo() {
  const [path] = useLocation();
  const { language } = useLanguage();
  useEffect(() => {
    const seo = getSeo(localizedPath(language, path));
    // All head tags use the same data source as the build-time HTML.
    document.head.querySelectorAll("[data-seo]").forEach(node => node.remove());
    const template = document.createElement("template");
    template.innerHTML = renderSeoHead(seo);
    document.head.appendChild(template.content);
  }, [language, path]);
  return null;
}
